import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { GetPointHistory } from 'services/Api/Module/PointHistory';
import helper from 'services/helper';
import moment from 'moment';

const HistoryPoint = () => {
    const location = useLocation();
    const [ pointHistory, setPointHistory ] = useState([])
    const [pointType, setPointType] = useState('');
    const [status, setStatus] = useState('loading');
    const [requestVersion, setRequestVersion] = useState(0);

    useEffect(() => {
        let active = true;

        const loadHistory = async () => {
            setStatus('loading');
            setPointHistory([]);
            // Recalculate on entry, including returns from point collection.
            const params = { date: moment().utcOffset(7 * 60).format('YYYY-MM-DD') };

            for (let attempt = 0; attempt < 2; attempt += 1) {
                let response;
                try {
                    response = await GetPointHistory({ params });
                    if (!active) return;

                    const resData = response?.data;
                    if (resData?.resultCode !== 20000 || !Array.isArray(resData.resultData)) {
                        throw new Error('Invalid history response');
                    }

                    setPointHistory(resData.resultData);
                    setStatus('success');
                    return;
                } catch (error) {
                    if (!active) return;

                    // The shared API client can resolve an Axios error instead of rejecting.
                    const httpStatus = response?.status ?? response?.response?.status ?? error?.response?.status;
                    const resultCode = response?.data?.resultCode ?? response?.response?.data?.resultCode ?? error?.response?.data?.resultCode;
                    const transient = (!httpStatus && !resultCode) || httpStatus >= 500 || (resultCode >= 50000 && resultCode < 60000);
                    if (attempt === 0 && transient) continue;

                    setStatus('error');
                    return;
                }
            }
        };

        loadHistory();
        return () => { active = false; };
    }, [location.key, requestVersion]);

    const pointHistoryFilter = pointHistory.filter(item => [1,2].includes(pointType) === false || item.pointType === pointType)
    return (
        <section id="pHistory" aria-busy={status === 'loading'}>
            <div className="bFilter">
                <div className="bTitle">
                    <h2>ประวัติการให้คะแนน</h2>
                </div>
                <div className="bCategory">
                    <a className={[1,2].includes(pointType) === false ? 'active': '' } onClick={() => setPointType(0)} >ทั้งหมด</a>
                    <a className={pointType === 1 ? 'active': '' } onClick={() => setPointType(1)}>ให้คะแนน</a>
                    <a className={pointType === 2 ? 'active': '' } onClick={() => setPointType(2)}>สแกนคูปอง</a>
                </div>
                </div>
                {
                    status === 'loading'
                    ? (
                        <div className="bCouponNone">
                            <div className="bText">
                                <p role="status">กำลังโหลดประวัติ...</p>
                            </div>
                        </div>
                    )
                    : status === 'error'
                    ? (
                        <div className="bCouponNone">
                            <div className="bText" role="alert">
                                <p>โหลดประวัติไม่สำเร็จ</p>
                                <button type="button" className="btn white" onClick={() => setRequestVersion(value => value + 1)}>
                                    ลองอีกครั้ง
                                </button>
                            </div>
                        </div>
                    )
                    :
                    pointHistoryFilter.length
                    ? (
                        <div className="bGroup">
                            {
                                pointHistoryFilter
                                .map(item => {
                                    return (
                                        <article data-type={item.pointType === 1 ? 'point' : 'coupon' } key={item.id}>
                                                <div className="bTitle">
                                                { item.pointType === 1 && (<h3>ให้คะแนน</h3>) }
                                                { item.pointType === 2 && (<h3>แลกคูปอง</h3>) }
                                            </div>
                                            <div className="bDetails">
                                                <div className="bRow">
                                                    <h4>วันที่/เวลา</h4>
                                                    <p>{item.createdOn ? helper.TIME.toShortDateTimeNormalLang(item.createdOn) : '-' }</p>
                                                </div>
                                                <div className="bRow">
                                                    <h4>ชื่อ</h4>
                                                    <p>{item.fullName ? item.fullName: '-' }</p>
                                                </div>
                                                <div className="bRow">
                                                    <h4>เบอร์โทรศัพท์</h4>
                                                    <p>{item.contactNumber ? helper.FORMAT.TEL(item.contactNumber) : '-' }</p>
                                                </div>
                                                <div className="bRow">
                                                    { item.pointType === 1 && (<h4>คะแนนที่ให้</h4>) }
                                                    { item.pointType === 2 && (<h4>คะแนนที่ใช้</h4>) }
                                                    <p>{item.point > 0 ? helper.FN.toNumberWithCommas(item.point): '0' } คะแนน</p>
                                                </div>
                                                <div className="bRow">
                                                    <h4>หมายเลขอ้างอิง</h4>
                                                    <p>{item.reference ? item.reference: '-' }</p>
                                                    
                                                </div>
                                                
                                                {item.pointType === 2 && (
                                                    <>
                                                        <div className="bRow">
                                                            <h4>ชื่อคูปอง</h4>
                                                            <p>{item.couponName ? helper.FN.splitText(item.couponName, 24) : '-' }</p>
                                                        </div>
                                                        <div className="bRow">
                                                            <h4>รหัสคูปอง</h4>
                                                            <p>{item.couponCode ? item.couponCode: '-' }</p>
                                                        </div>
                                                    </>
                                                )}
                                                
                                            </div>
                                        </article>
                                    )
                                })
                            }
                             
                        </div>
                    )
                    : (
                        
                        <div className="bCouponNone">
                            {/* <!-- เปิด-ปิด ด้วย class hide หรือ ลบ .bCouponNone ออก --> */}
                            <div className="bText">
                                <i></i>
                                <p>ไม่มีข้อมูล</p>
                            </div>
                        </div>
                    )
                }
        </section>   
    )
}

export default HistoryPoint

